export default __webpack_public_path__ + "static/media/home.2690f8cc.svg";